import { useEffect, useState } from "react"
import Button1 from "../../form/Button1"
import TextInput from "../../form/TextInput"
import { MenuItem, TextField } from "@mui/material"
import BookingClassInput from "../../form/Flight/BookingClassInput"
import ExpandWrapper from "../../DIsplay/ExpandWrapper"
import { cabinClassData } from "../../../data/flight/bookingConstants"
import { TimePicker } from "@mui/x-date-pickers"
import moment from "moment"
import AirlinesInput from "../../form/AirlinesInput"
import CitiesInput from "../../form/CitiesInput"
import { CompareFlightChange } from "./CompareFlightChange"

export default function ManualFlightDetailForm({data,setData,dataObj,returnExpands,updateComponent}) {
  const [expands,setExpands] = useState([])
  const [lockUpd,setLockUpd] = useState(true);

  useEffect(() => {
    returnExpands && returnExpands(expands)
    //eslint-disable-next-line
  },[expands])
  
  function handleChange(obj,i,config) {
    const {unlockUpd} = config || {}
    try {
      const temp = {...data} 

      temp.flights[i] = {...temp.flights[i],...obj}

      setData(temp)
      
      if(unlockUpd)
        setLockUpd(false);
    } catch(ex) {/**/}
  }

  console.log(data)
  
  return (
    <div>
      {data?.flights?.map((flight,i) => (
        <ExpandWrapper open={expands[i]} key={i}>
          {(value) => {
            const {open,setOpen} = value || {}
            const handleOpen = (id) => {
              const element = document.getElementById(id);
              if(element)
                setTimeout(() => 
                  element?.scrollIntoView({behavior: 'instant'})
                ,500)
              console.log(element)
              setOpen(!open)
              setExpands([...Array(data?.flights?.length)].map((_,j) => j===i && !open))
            }

            return (
              <div className="my-4 max-w-full" id={'pass'+i}>
                <div className="rounded-md border border-gray-300 light-bg flex flex-wrap gap-4 p-4 items-center">
                  <div className='flex-1'>
                    {flight?.departureLocationName} - {flight?.arrivalLocationName}
                  </div>

                  <div>
                    <Button1 variant='outlined' onClick={() => handleOpen('pass'+i)} className='!flex !gap-2 !font-bold'><span>{open?'Close':'Edit Flight'}</span></Button1>
                  </div>
                </div>

                {open?
                  <div className="p-4 pb-0">
                    <CompareFlightChange data={{oldOrder: dataObj,flight: dataObj,modSegment: flight,query: dataObj, i}} />
                  </div>
                :null}
                {open?
                  <div className='flex flex-col gap-4 py-4'>
                    <div className="flex gap-4">
                      <TextField type='date' label='Departure'  name='date' className='flex-1'
                        value={flight?.departureDate}
                        // disabled
                        onChange={(ev) => handleChange({departureDate: moment(ev?.target?.value).format('YYYY-MM-DD')},i)}
                        inputProps={{
                          min: new Date().toISOString().split('T')[0]
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}/>
                      <TextField type='date' label='Arrival'  name='date' className='flex-1'
                        value={flight?.arrivalDate}
                        onChange={(ev) => handleChange({arrivalDate: moment(ev?.target?.value).format('YYYY-MM-DD')},i)}
                        inputProps={{
                          min: new Date().toISOString().split('T')[0]
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}/>
                    </div>
                    <div className="flex gap-4">
                      <div className="flex-1">
                        <TimePicker className="w-full" label='Departure Time' value={moment(flight?.departureTime,'hh:mm aa')} 
                          onChange={(val) => handleChange({departureTime: val.format('hh:mm A')},i)}
                          />
                      </div>
                      <div className="flex-1">
                        <TimePicker className="w-full" label='Arrival Time' value={moment(flight?.arrivalTime,'hh:mm aa')} 
                          onChange={(val) => handleChange({arrivalTime: val.format('hh:mm A')},i)}
                          />
                      </div>
                    </div>
                    <div className='flex gap-4 items-center'>
                      <div className="flex-1">
                        <TextInput label='Aircraft Code' value={flight?.aircraftCode} onChange={(ev) => handleChange({aircraftCode: ev?.target?.value},i)} />
                      </div>
                      <div className="flex-1">
                        <TextInput label='Flight Number' value={flight?.flightNumber} onChange={(ev) => handleChange({flightNumber: ev?.target?.value},i)} />
                      </div>
                    </div>
                    <div className='flex gap-4 items-center'>
                      <div className='flex-1'>
                        <TextInput select label='Cabin Class' value={flight?.cabinClass} onChange={(ev) => handleChange({cabinClass: ev?.target?.value},i)}>
                          {cabinClassData?.map((obj,i) => (
                            <MenuItem key={i} value={obj?.value?.toUpperCase()}>{obj?.label}</MenuItem>
                          ))}
                        </TextInput>
                      </div>
                      <div className='flex-1'>
                        <BookingClassInput value={flight?.bookingClass} setValue={(bookingClass) => handleChange({bookingClass},i)} />
                      </div>
                    </div>
                    
                    <div className="flex gap-4">
                      <CitiesInput 
                        lockUpdate={lockUpd}
                        className={'flex-1'} label={'Departure Airport'} value={flight?.departureAirport} onChange={(obj) => handleChange({departureAirport: obj?.name || obj},i,{unlockUpd: true})} />
                      <CitiesInput 
                        lockUpdate={lockUpd}
                        className={'flex-1'} label={'Arrival Airport'} value={flight?.arrivalAirport} onChange={(obj) => handleChange({arrivalAirport: obj?.name || obj},i,{unlockUpd: true})} />
                    </div>
                  </div>
                :null}

                {open?
                  updateComponent
                :null}
              </div>
            )
          }}
        </ExpandWrapper>
      ))}
    </div>
  )
}